import { createAction } from 'redux-actions';

import {
  TRACK_CHECK_PERCENTAGE,
  TRACK_EXTERNAL,
  TRACK_LOAD_CUSTOM_OPTIONS,
  TRACK_START,
  TRACK_QUARTER,
  TRACK_HALF,
  TRACK_THREE_QUARTERS,
  TRACK_END,
} from './types';

export const checkPercentage = createAction(TRACK_CHECK_PERCENTAGE);
export const loadCustomOptions = createAction(TRACK_LOAD_CUSTOM_OPTIONS);
export const trackExternal = createAction(TRACK_EXTERNAL);
export const trackStart = createAction(TRACK_START);
export const trackQuarter = createAction(TRACK_QUARTER);
export const trackHalf = createAction(TRACK_HALF);
export const trackThreeQuarters = createAction(TRACK_THREE_QUARTERS);
export const trackEnd = createAction(TRACK_END);
